module.exports = __webpack_public_path__ + "img/Still-Thinking-Inspect-Large.b2234983.png";